import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import {
  TemplateObjectType,
  TemplatesAPI,
  TemplateState,
} from 'data/templates/api';
import { TaskTemplate } from 'data/templates/tasks';
import { logger } from 'services';
import {
  CreateDocumentHighlightTaskPayload,
  createDocumentTemplateHighlightTaskAction,
} from '../../actions';
import { createDocumentTemplateHighlightTask } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';

function* createDocumentTemplateHighlightTaskSaga(
  action: PayloadAction<CreateDocumentHighlightTaskPayload>,
) {
  const {
    payload: { task, docId, resourceSectionId, sectionId },
  } = action;

  try {
    const _taskTemplate: TaskTemplate = {
      templateId: 'new',
      templateName: task.taskName,
      templateContent: {
        private: false,
        ...task,
      },
      objectType: TemplateObjectType.Task,
      state: TemplateState.Published,
    };

    const taskTemplate: TaskTemplate = yield TemplatesAPI.save<TaskTemplate>(
      _taskTemplate,
    );

    yield put(
      createDocumentTemplateHighlightTask({
        docId,
        resourceSectionId,
        sectionId,
        task: {
          ...taskTemplate.templateContent,
          taskId: taskTemplate.templateId as number,
        },
      }),
    );

    yield saveDocumentTemplate(docId);
  } catch (error) {
    logger.error('an error creating a task on the highlighted text', { error });

    message.error('There was an error creating a task on the highlighted text');
  }
}
export const watchCreateDocumentTemplateHighlightTaskSaga = function* () {
  yield takeLatest(
    createDocumentTemplateHighlightTaskAction.type,
    createDocumentTemplateHighlightTaskSaga,
  );
};
